const TEMP_ID = 'a@a.com';
const TEMP_PW = '1234';

export const USER_AUTH_TOKEN = btoa(`${TEMP_ID}:${TEMP_PW}`);
